<template>
    <van-row class="header_container">
        <van-col span="3" class="header_col">
            <img src="@/assets/common/icon_back.png" alt="" @click="handleBackClick">
        </van-col>
        <van-col span="18" class="header_col">
            {{ props.text }}
        </van-col>
        <van-col span="3" class="history-col" v-if="showHistory">
            <div @click="() => emits('openHistoryPopup')">
                {{ $t('common.history') }}
                <van-icon name="play" style="padding-top: 2px;" />
            </div>
        </van-col>
        <van-col span="3" class="history-col" v-if="showFund">
            <div @click="() => emits('goToFund')">
                <van-icon name="orders-o" size="25"/>
            </div>
        </van-col>
    </van-row>
</template>

<script setup lang="ts">
import { useUserStore } from '@/stores/user'
import { navToBack } from '@/view/components/supportFunction'
import { useRouter } from 'vue-router'
const router = useRouter()
const userStore = useUserStore()
const props = defineProps({
    text: {
        type: String,
        default: () => ''
    },
    isShowRightIcon: {
        type: Boolean,
        default: () => false
    },
    isPopupCloseBackIcon: {
        type: Boolean,
        default: () => false
    },
    showHistory: {
        type: Boolean,
        default: () => false
    },
    showFund: {
        type: Boolean,
        default: () => false
    },
})
const emits = defineEmits(['closePopup', 'openHistoryPopup', 'goToFund'])

const handleBackClick = () => {
    navToBack(router, props.isPopupCloseBackIcon, emits)
    userStore.setRechargeBonusType(0)
}

</script>
<style scoped>
.header_container {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    background: #27190D !important;
    color: #ffffffd9;
    padding: 5px 12px;
    z-index: 1000;
}

.header_col img {
    width: 40px;
}

.header_col {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
}

.history-col {
    font-size: 0.65rem;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    text-align: center;
}
</style>